import { useAuthState } from '../useAuthState'

export const useFlowpagePermissionsEnabled = (): boolean => {
  const { hasOperation } = useAuthState()
  return hasOperation('view:flowpage_permissions')
}
